module.exports = __webpack_public_path__ + "img/btn-edite.ba1dec2b.svg";